var bn = require('bn.js');
function withPublic(paddedMsg, key) {
  return new Buffer(paddedMsg
    .toRed(bn.mont(key.modulus))
    .redPow(new bn(key.publicExponent))
    .fromRed()
    .toArray());
}

module.exports = withPublic;


//////////////////
// WEBPACK FOOTER
// ./~/public-encrypt/withPublic.js
// module id = 447
// module chunks = 0